import { useEffect, useState } from 'react';

import { ProfessionalAvatar } from '@/components/ProfessionalAvatar';
import { formatPracticeWelcome } from '@/util/practice';
import { LandingPageFooter } from '@/pages/onboarding/LandingPageFooter';
import { PatientPageLayout } from '@/components/PatientPageLayout';
import { Practice } from '@aldebaran/prisma';

interface PracticeLandingProps {
  practice: Practice | undefined;
  consultationDate: Date | undefined;
  onPrepareConsultation: () => void;
}

const MALE_AVATAR_PLACEHOLDER = {
  firstname: '',
  lastname: '',
  title: '',
  avatarId: null,
  gender: 'MALE' as const,
};

export const PracticeLanding = ({
  practice,
  consultationDate,
  onPrepareConsultation,
}: PracticeLandingProps) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const avatarSize =
    window.innerWidth >= 640
      ? windowHeight <= (consultationDate ? 580 : 530)
        ? 100
        : 140
      : 120;

  return (
    <PatientPageLayout
      title={
        <div className="flex flex-col items-center justify-center text-center">
          <div className="sm:text-medium sm:px-4 text-3.5xl font-semibold w-full text-secondary">
            {practice?.name
              ? formatPracticeWelcome(practice)
              : 'Bienvenue au cabinet'}
          </div>
        </div>
      }
      titleClassName="text-center"
      contentClassName="flex flex-col items-center justify-center text-center text-base"
      footerClassName="!border-0"
      footer={
        <div className="w-full flex flex-col items-center justify-center gap-4">
          <LandingPageFooter
            consultationDate={consultationDate}
            buttonLabel="Préparer la consultation"
            onClick={onPrepareConsultation}
          />
        </div>
      }
    >
      <div className="w-full flex flex-col text-center mt-2 sm:mt-0">
        <div className="relative w-full flex items-start justify-center">
          <div className="flex flex-nowrap justify-center gap-x-6 pt-2 mx-6 px-2">
            <div className="flex flex-col justify-center items-center gap-3 w-40 mb-4">
              <ProfessionalAvatar
                professional={{
                  ...MALE_AVATAR_PLACEHOLDER,
                  avatarId: practice?.avatarId ?? null,
                }}
                size={avatarSize}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center gap-y-2 w-full">
        <div className="text-base w-full mt-2">
          <p
            className={`px-4 ${
              consultationDate ? 'nsm:mmh44:hidden' : 'nsm:mmh39:hidden'
            }`}
          >
            Votre cabinet utilise désormais <br /> Aldebaran, une aide médicale
            pour
            <br />
            <span className="text-secondary">
              améliorer la qualité de vos soins.
            </span>
          </p>
        </div>
      </div>
    </PatientPageLayout>
  );
};
